import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/memberVisitsSaga";
import { useDateFormat } from "../../../../hooks/useDateFormat";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";

const DatePicker = () => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();

  const { startDate, endDate } = useSelector(
    (state) => state.memberVisits.selectedFilters.requestDates
  );
  const { calendarEndDate, calendarStartDate } = useSelector(
    (state) => state.memberVisits.currentUser
  );

  const handleUpdateDates = (startDate, endDate) => {
    dispatch(actionCreators.updateDates({ startDate, endDate }));
  };

  return (
    <div className="date-select-box select-box ">
      <p className="offers-title">Date</p>
      <ReactDatePicker
        displayFormat={dateFormat}
        startDate={startDate}
        endDate={endDate}
        calendarEndDate={calendarEndDate}
        isRangePicker
        minDate={calendarStartDate}
        updateDates={handleUpdateDates}
      />
    </div>
  );
};

export default DatePicker;
